import Interaction from 'ol/interaction/Interaction';
import { addHelpTooltipToMap, hideHelpTooltip, removeHelpTooltipFromMap, updateHelpTooltip } from 'cadenza/map/interactions/draw-interaction';
import { on, unByKey as browserUnByKey } from 'cadenza/utils/event-util';
import { unByKey as olUnByKey } from 'ol/Observable';

export class TooltipInteraction extends Interaction {

  #map;
  #helpTooltip;
  #browserEventKeys;
  #olEventKeys;
  #helpMessage;

  constructor (map, tooltipHelpMessage, interactionOptions = {}) {
    super(interactionOptions);
    this.setActive(false);
    this.#map = map;
    this.#helpMessage = tooltipHelpMessage;

    this.on('change:active', () => {
      if (this.getActive()) {
        this._onActivation();
      } else {
        this._onDeactivation();
      }
    });
  }

  get map () {
    return this.#map;
  }

  _onActivation () {
    this.#helpTooltip = addHelpTooltipToMap(this.#map, { helpMessage: this.#helpMessage });

    this.#browserEventKeys = on(this.#map.getViewport(), 'mouseout', () => hideHelpTooltip(this.#helpTooltip));
    this.#olEventKeys = this.#map.on('pointermove', event => updateHelpTooltip(this.#helpTooltip, event));
  }

  _onDeactivation () {
    removeHelpTooltipFromMap(this.#helpTooltip, this.#map);
    this.#helpTooltip = null;

    browserUnByKey(this.#browserEventKeys);
    olUnByKey(this.#olEventKeys);
  }

}
